import React, { useState, useEffect } from 'react';
import styles from '../Lists.module.css';
import { ListCommand } from '../../../types/ListCommands';

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

interface QueueViewProps {
  command: ListCommand | null;
  onComplete: () => void;
}
const QueueView: React.FC<QueueViewProps> = ({ command, onComplete }) => {
  const [queue, setQueue] = useState<number[]>(() => 
    Array.from({ length: 5 }, () => Math.floor(Math.random() * 100))
  );  
  const [highlightedIndex, setHighlightedIndex] = useState<number | null>(null);
  const [operation, setOperation] = useState<'enqueue' | 'dequeue' | null>(null);
  useEffect(() => {
    if (command) executeCommand(command);
  }, [command]);

  const executeCommand = async (cmd: ListCommand) => {
    switch (cmd.action) {
      case 'addLast':
        if (queue.length < 8) {
          setOperation('enqueue');
          setQueue(prev => [...prev, cmd.value]);
          setHighlightedIndex(queue.length);
          await delay(500);
        }
        break;
      case 'removeFirst': 
        if (queue.length > 0) {
          setOperation('dequeue');
          setHighlightedIndex(0);
          await delay(500);
          setQueue(prev => prev.slice(1));
        }
        break;
      case 'removeLast':
        if (queue.length > 0) {
          setOperation('dequeue');
          setHighlightedIndex(queue.length - 1);
          await delay(500);
          setQueue(prev => prev.slice(0, -1));
        }
        break;
      case 'reset':
        const newRandomState = Array.from({ length: 5 }, () => Math.floor(Math.random() * 100));
        setQueue(newRandomState);
        await delay(300);
        break;
    };
  
    setHighlightedIndex(null);
    setOperation(null);
    onComplete();
  };

  return (
    <div className={styles.comparisonContainer}>
      <h3 className={styles.comparisonTitle}>Queue (FIFO)</h3>
      <div className={styles.visualization}>
        <div className={styles.stackContainer}>
          {queue.map((value, index) => (
            <div
              key={index}
              className={`${styles.node} ${highlightedIndex === index ? styles.highlighted : ''} ${(operation === 'dequeue' && highlightedIndex === index) ? styles.popEffect : ''}`}
            >
              {value}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QueueView;